import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { PatientService } from '../patient.service';
import { MatDialog } from '@angular/material/dialog';
import { IconRegistryService } from '../../../utilities/icon-registry.service';
import { AutofillService } from '../../../services/autofill.service';
import { AddressDataModel } from '../../../models/person/address-data.model';
import { stateList } from '../../../constants';
import { UiService } from '../../../services/ui.service';
import { DialogService } from '../../../services/dialog.service';
import { StaticDataService } from '../../../services/static-data.service';
import DevExpress from 'devextreme';
import { EnumValidValueItemModel } from '../../../models/enum/enum-valid-value-item.model';
import { PatientDialogDataModel } from '../patient-dialog-data.model';
import { OfficeLocationsService } from '../../configuration/office-locations/office-locations.service';
import { Globals } from '../../../globals';
import { TdoAccordionComponent } from '../../../tdo-controls/common/tdo-accordion/tdo-accordion.component';
import { PatientDataModel } from '../../../models/patient/patient-data.model';
import { OrganizationsService } from '../../configuration/organization-configuration/organizations-service';
import { DoctorsService } from 'src/app/services/doctors.service';
import { ChangeDetectorRef } from '@angular/core';


@Component({
    selector: 'app-patient-address',
    templateUrl: './patient-address.component.html',
    styleUrls: ['./patient-address.component.css']
})
export class PatientAddressComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() currentContactId: string;
    @Input() currentContact: any;
    @Input() data: AddressDataModel[];
    @Input() patient: PatientDataModel;
    @Input() mode = '';
    @Input() type = 'patient';
    @Input() disabled: boolean = false;
    @Input() allowMultiple: boolean = true;
    @Input() isAutoOpenFirstItem: boolean = false;

    @Output() dataChange = new EventEmitter();
    @Output() errorEvent = new EventEmitter();
    @Output() claimBillingBlocked = new EventEmitter<void>();

    @ViewChild('accordion') accordion: TdoAccordionComponent;

    isLoading: boolean = false;
    step: number = 0;
    stateList: string[];
    stateListEnums: EnumValidValueItemModel[];
    selectedAddress: AddressDataModel;
    addressCategoryEnums: EnumValidValueItemModel[];
    claimBillingCategory = '00000008-1000-0000-0000-000000000005';
    mainAddressCategory = '00000008-1000-0000-0000-000000000003';


    constructor(
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        private patientService: PatientService,
        private doctorsService: DoctorsService,
        private organizationService: OrganizationsService,
        private autofillService: AutofillService,
        iconRegistry: IconRegistryService,
        private dialogService: DialogService,
        private staticDataService: StaticDataService,
        private globals: Globals,
        public uiService: UiService) {
        iconRegistry.registerIcon('send-email', 'assets/icons/icons8-send-email.svg');
        this.stateList = stateList;
    }

    ngOnInit() {
        if (!this.staticDataService.isReady) {
            this.staticDataService.validValuesReadyEvent.subscribe({
                complete: () => {
                    this.stateListEnums = this.staticDataService.getValidValueItemsByValidValueName('enumStateProvince');
                    this.addressCategoryEnums = this.staticDataService.getValidValueItemsByValidValueName('enumAddressCategory');
                }
            });
        } else {
            this.stateListEnums = this.staticDataService.getValidValueItemsByValidValueName('enumStateProvince');
            this.addressCategoryEnums = this.staticDataService.getValidValueItemsByValidValueName('enumAddressCategory');
        }
    }

    ngAfterViewInit(): void {
        if (this.isAutoOpenFirstItem) {
            const ivl = setInterval(() => {
                if (this.accordion.items.length === 0) {
                    return;
                }
                clearInterval(ivl);
                this.accordion.items.get(0).isExpanded = true;
            }, 200);
        }
    }

    sendData() {
        this.dataChange.emit(this.data);
    }
    deleteAddress(event: MouseEvent, address) {
        event.stopImmediatePropagation();
        this.dialogService.openConfirmDialog('Are you sure you want to delete this address?').subscribe((result) => {
            if (result) {
                if (address.AddressId) {
                    if (this.type === PatientDialogDataModel.TYPE_ORGANIZATION) {
                        this.organizationService.deleteOrganizationAddress(address.AddressId).subscribe(() => {
                            const idx = this.data.findIndex(p => p.AddressId === address.AddressId);
                            if (idx > -1) {
                                this.data.splice(idx, 1);
                            }
                        });
                    }
                    else {
                        this.patientService.deleteAddress(address.AddressId).subscribe((res) => {
                            const idx = this.data.findIndex(p => p.AddressId === address.AddressId);
                            if (idx > -1) {
                                this.data.splice(idx, 1);
                            }
                        });
                    }
                }
                else {
                    const idx = this.data.findIndex(p => p === address);
                    if (idx > -1) {
                        this.data.splice(idx, 1);
                    }
                }
                this.sendData();

            }
        });
    }

    addNewAddress() {
        if (this.disabled)
            return;

        if (!this.data) {
            this.data = [];
        }

        this.isLoading = true;
        if (this.type === PatientDialogDataModel.TYPE_ORGANIZATION) {
            const newAddress = new AddressDataModel();
            newAddress.LOCID = this.globals.LOCID;
            newAddress.Address1 = '';
            newAddress.Address2 = '';
            newAddress.Address3 = '';
            newAddress.PostCode = '';
            newAddress.State = '';
            newAddress.City = '';
            newAddress.enumAddressCategoryID = '';
            newAddress.Suburb = '';
            this.data.unshift(newAddress);
        }
        else if (this.type === PatientDialogDataModel.TYPE_PATIENT) {
            this.patientService.getNewContactAddress(this.currentContactId)
                .subscribe(response => {
                    this.isLoading = false;
                    if (response) {
                        const sub = this.accordion.childItemsUpdate.subscribe((items) => {
                            items[items.length - 1].isExpanded = true;
                            sub.unsubscribe();
                        });

                        this.data.push(response);
                        this.step = this.data.length - 1;
                    } else {
                        this.sendError('Something went wrong when adding a new address');
                        console.log('error: no response');
                    }
                }, err => {
                    this.isLoading = false;
                    this.sendError('Something went wrong when adding a new address');
                    console.log('error', err);
                });
        }
        else if (this.type === PatientDialogDataModel.TYPE_DOCTOR) {
            this.doctorsService.getNewContactAddress(this.currentContactId)
                .subscribe(response => {
                    this.isLoading = false;
                    if (response) {
                        const sub = this.accordion.childItemsUpdate.subscribe((items) => {
                            items[items.length - 1].isExpanded = true;
                            sub.unsubscribe();
                        });

                        this.data.push(response);
                        this.step = this.data.length - 1;
                    } else {
                        this.sendError('Something went wrong when adding a new address');
                        console.log('error: no response');
                    }
                }, err => {
                    this.isLoading = false;
                    this.sendError('Something went wrong when adding a new address');
                    console.log('error', err);
                });

        }
        this.sendData();

    }

    sendError(message) {
        this.errorEvent.emit(message);

    }

    onAddress1Blur(event: any) {
        if (event) {
            this.autofillService.getAddressDataFromInput(event).subscribe((response) => {
                this.selectedAddress.City = response.city;
                this.selectedAddress.State = response.state;
                this.selectedAddress.PostCode = response.zipcode;
                this.selectedAddress.enumStateProvinceID = this.getStateEnumFromName(response.state);
                this.selectedAddress.Address1 = event;
            });
        }
    }

    onZipCodeInput(event, address: AddressDataModel) {
        address.PostCode = event.target.value;
        if (event.target.value.length === 5) {
            this.autofillService.getAddressDataFromInput(event.target.value).subscribe((response) => {
                this.selectedAddress.City = response.city;
                this.selectedAddress.State = response.state;
                this.selectedAddress.enumStateProvinceID = this.getStateEnumFromName(response.state);

            });
        }
    }

    onAddressCategoryChange(event: any, address: AddressDataModel) {
        if (this.addressCategoryEnums) {
            const previousValue = address.enumAddressCategoryID;
            const valueToMatch = typeof event === 'string' ? event : event.ValidValueItemId;
            const model = this.addressCategoryEnums.find(p => p.ValidValueItemId === valueToMatch);
            if (!model) return;

            const isSelectingClaimBilling = model.ValidValueItemId === this.claimBillingCategory;
            const isAlreadyClaimBilling = address.enumAddressCategoryID === this.claimBillingCategory;

            // Block multiple Claim Billing assignments for organizations
            if (this.type === 'organization' && isSelectingClaimBilling && !isAlreadyClaimBilling) {
                const existingClaimBilling = this.data?.filter(a =>
                    a.enumAddressCategoryID === this.claimBillingCategory
                ).length;

                if (existingClaimBilling >= 1) {
                    this.sendError('There is already a Claim Billing address.');
                    address.enumAddressCategoryID = previousValue;
                    this.claimBillingBlocked.emit();
                    this.cdr.detectChanges();
                    return;
                }
            }


            address.enumAddressCategoryID = model.ValidValueItemId;
            address.typeDescription = model.ItemDisplayValue;
            this.cdr.detectChanges();
        }
    }

    getAddressCategory(cat: string) {
        if (!this.staticDataService.validValueItems) {
            return;
        }
        const enu = this.staticDataService.validValueItems.find(p => p.ValidValueItemId === cat);
        if (enu) {
            return enu.ItemDisplayValue;
        }

        return '';
    }

    getAddress(address: AddressDataModel) {

        let ret = '';
        if (address) {
            if (address.Address1) {
                ret += address.Address1;
            }
            if (address.City) {
                ret += ' ' + address.City;
            }
            if (address.State) {
                ret += ', ' + address.State;
            }
            if (address.PostCode) {
                ret += ', ' + address.PostCode;
            }
        }
        return ret;
    }

    onStateChange(event: EnumValidValueItemModel, address: AddressDataModel) {
        // const model = this.stateListEnums.find(p => p.ValidValueItemId === event);
        const model = this.stateListEnums.find(p => p.ValidValueItemId.toLowerCase() === event.ValidValueItemId.toLowerCase());
        if (model) {
            address.State = model.ItemSValue;
            address.enumStateProvinceID = model.ValidValueItemId;
            this.sendData();
        }
    }

    onAccordionItemClick(address: AddressDataModel) {
        this.selectedAddress = address;
    }

    onInputFinished(address: AddressDataModel, property: string, event: any) {
        this.autofillService.getAddressDataFromInput(event).subscribe((response) => {
            if (property === 'City') {
                this.selectedAddress.PostCode = response.zipcode;
            } else if (property === 'PostCode') {
                this.selectedAddress.City = response.city;
                this.selectedAddress.PostCode = event;
            }

            const stateEnu = this.stateListEnums.find(p => p.ItemDisplayValue.toLowerCase() === response.state.toLowerCase());
            this.selectedAddress.State = stateEnu.ItemSValue;
            this.selectedAddress.enumStateProvinceID = stateEnu.ValidValueItemId;
            // Debug the updated address
        });
    }

    getStateFromEnum(enumStateProvinceID: string) {
        if (this.stateListEnums && enumStateProvinceID) {
            return this.stateListEnums.find(p => p.ValidValueItemId === enumStateProvinceID).ValidValueItemId;
        }
    }

    getStateEnumFromName(stateName: string) {
        if (this.stateListEnums && stateName) {
            return this.stateListEnums.find(p => p.ItemDisplayValue.toLowerCase() === stateName.toLocaleLowerCase()).ValidValueItemId;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.data && changes.data.currentValue !== changes.data.previousValue) {
            if (this.isAutoOpenFirstItem) {
                const ivl = setInterval(() => {
                    if (this.accordion?.items?.length === 0) {
                        return;
                    }
                    clearInterval(ivl);
                    this.accordion.items.get(0).isExpanded = true;
                }, 10);
            }
            this.sendData();
        }
    }

    copyPatientAddress() {
        // this.selectedAddress.Address1 = this.patient.dataContact.
        const patientAddresses = this.patient.dataContact.dataAddresses;
        for (const addr of patientAddresses) {
            const mod = new AddressDataModel();
            mod.ContactId = this.currentContactId;
            mod.Address1 = addr.Address1;
            mod.Address2 = addr.Address2;
            mod.Address3 = addr.Address3;
            mod.City = addr.City;
            mod.enumStateProvinceID = addr.enumStateProvinceID;
            mod.State = addr.State;
            mod.PostCode = addr.PostCode;
            mod.Suburb = addr.Suburb;
            mod.LOCID = addr.LOCID;
            mod.enumAddressCategoryID = addr.enumAddressCategoryID;
            mod.addrDescription = addr.addrDescription;
            mod.enumCountryID = addr.enumCountryID;
            this.data.unshift(mod);
        }
        this.sendData();
    }
}
